import {useDraggable} from '@dnd-kit/core';
import {getSize} from 'platform/foundation';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface ResizeHandlerProps extends RequiredTestIdProps {
  eventId: string;
  direction: 'bottom';
  isReadOnly?: boolean;
}

export function ResizeHandler(props: ResizeHandlerProps) {
  const {
    attributes: resizeAttributes,
    listeners: resizeListeners,
    setNodeRef: resizeSetNodeRef,
  } = useDraggable({
    id: `${props.eventId}-resize`,
    data: {
      type: 'resize',
      direction: props.direction,
      eventId: props.eventId,
    },
    disabled: props.isReadOnly,
  });
  return (
    <div
      ref={resizeSetNodeRef}
      {...resizeListeners}
      {...resizeAttributes}
      className="absolute left-0 w-full cursor-row-resize rounded-xs bg-[var(--color-palettes-black-900-60)] opacity-0 transition-opacity duration-100 ease-in-out hover:opacity-60"
      style={{bottom: props.direction === 'bottom' ? 0 : 'auto', height: getSize(3)}}
      data-testid={suffixTestId('resizeHandler', props)}
    />
  );
}
